
const common = {
  // Navigation
  brand_story: "브랜드 스토리",
  our_philosophy: "우리의 철학", 
  product_series: "제품 시리즈",
  global_sourcing: "글로벌 소싱",
  start_journey: "여행 시작",
  
  // Hero Section
  hero_title: "젊음의",
  hero_title_highlight: "권리를 되찾다",
  hero_description: "LunaKey는 자연에서 가장 효과적인 슈퍼푸드를 제공하며, 과학적으로 제작되어 당신의 일상 의식에 통합되어 광채와 영원한 활력을 발산할 수 있게 합니다.",
  hero_cta: "당신의 여행을 시작하세요",
  
  // Story Section
  story_title: "신화에서 현대로",
  story_subtitle: "전설에서 현실로",
  story_description_1: "고대 전설에서 루나 여신은 달빛 아래에서 영혼의 사슴과 함께 춤추며 자연의 비밀과 생명의 활력을 지켰습니다. 이 신화적인 힘은 이제 현대 과학의 정밀한 추출을 통해 당신 손에 있는 모든 LunaKey 제품으로 변화했습니다.",
  story_description_2: "우리는 '자연이 힘을 주고, 과학이 권리를 확인한다'는 이념을 고수하며, 세계에서 가장 귀중한 슈퍼푸드를 엄격한 과학적 공정을 통해 당신의 일상 생활의 활력원으로 변화시킵니다.",
  story_quote: "우리는 시간과 싸우는 것이 아니라, 시간 속에서 젊음을 느끼는 당신의 권리를 재구성합니다.",
  
  // Philosophy Section
  philosophy_title: "우리의 철학",
  philosophy_subtitle: "삼위일체 가치 체계로 당신의 건강한 라이프스타일 구축",
  natures_proof: "자연의 증명",
  natures_proof_subtitle: "자연의 증명",
  natures_proof_description: "전 세계에서 조달된 고효율 슈퍼푸드, 인공 첨가물 제로. 모든 제품은 자연의 가장 순수한 힘을 담고 있으며, 엄격한 선별과 과학적 검증을 거쳤습니다.",
  empowered_confidence: "힘을 받은 자신감",
  empowered_confidence_subtitle: "힘을 받은 자신감",
  empowered_confidence_description: "자신의 건강을 통제하는 것에서 오는 여유와 안심을 느끼세요. LunaKey를 선택할 때, 당신은 자신에 대한 최고의 투자와 관심을 선택하는 것입니다.",
  your_vitality: "당신의 활력, 당신의 권리",
  your_vitality_subtitle: "당신의 활력, 당신의 권리",
  your_vitality_description: "적극적인 자기 관리와 건강 주권에 관한 선언. 당신은 최고의 상태를 가질 권리가 있고, 생명의 무한한 활력을 느낄 권리가 있습니다.",
  
  // Products Section
  products_title: "당신의 권리, 여기서 재구성",
  products_subtitle: "두 가지 주요 제품 시리즈로 당신의 건강과 아름다움을 포괄적으로 지원",
  proof_series: "권리 증명 시리즈",
  proof_series_subtitle: "권리 증명 시리즈",
  proof_series_description: "전 세계 최고급 슈퍼푸드를 엄선하여 당신의 건강에 가장 강력한 증명을 제공합니다. 모든 제품은 엄격한 품질 관리를 거쳐 가장 순수한 영양 보충을 보장합니다.",
  declaration_series: "에너지 선언 시리즈",
  declaration_series_subtitle: "에너지 선언 시리즈",
  declaration_series_description: "현대 라이프스타일을 위해 설계된 에너지 보충 솔루션으로, 바쁜 일상에서도 최적의 상태를 유지하고 내면의 광채와 활력을 보여줄 수 있습니다.",
  acai_powder: "아사이 파우더",
  acai_description: "항산화제 풍부, 면역력 향상",
  white_tomato: "화이트 토마토 파우더",
  white_tomato_description: "천연 미백, 피부 광채 발산",
  glow_booster: "글로우 부스터",
  glow_description: "내외겸수, 자연스러운 광채 피어남",
  energy_elixir: "에너지 엘릭서",
  energy_description: "지속적 에너지, 무한한 잠재력 발휘",
  learn_more: "더 알아보기",
  
  // Sourcing Section
  sourcing_title: "사슴의 발자취를 따라",
  sourcing_subtitle: "영혼의 사슴 발자취를 따라 세계에서 가장 귀중한 슈퍼푸드 원산지 탐색",
  brazil: "브라질",
  brazil_ingredient: "아사이 베리",
  brazil_description: "아마존 열대우림 깊숙한 곳의 보라색 보석, 안토시아닌과 항산화제가 풍부하여 자연이 준 젊음의 암호입니다.",
  peru: "페루",
  peru_ingredient: "마카 뿌리",
  peru_description: "안데스 산맥 고원의 에너지원, 천년 동안 '페루 인삼'으로 칭송받으며 몸에 지속적인 활력을 주입합니다.",
  himalaya: "히말라야",
  himalaya_ingredient: "구기자",
  himalaya_description: "세계의 지붕 위의 붉은 보석, 극지 환경에서 키워진 초강 생명력, 몸과 마음을 자양하는 천연 양약.",
  mediterranean: "지중해",
  mediterranean_ingredient: "올리브 잎",
  mediterranean_description: "지중해 햇살 아래의 녹색 정수, 천년의 건강 지혜를 담고 현대 생활에 순수한 보호를 가져다줍니다.",
  
  // Newsletter Section
  newsletter_title: "활력 리뉴얼 가이드 받기",
  newsletter_description: "우리의 전용 콘텐츠를 구독하여 최신 건강 정보, 제품 업데이트, 전문 영양 조언을 받고 당신의 활력 여행을 시작하세요.",
  email_placeholder: "당신의 이메일 주소",
  subscribe: "구독",
  subscribing: "구독 중...",
  subscribe_success: "구독 성공! LunaKey 가족에 합류해 주셔서 감사합니다.",
  subscribe_error: "구독에 실패했습니다. 나중에 다시 시도해 주세요.",
  privacy_notice: "우리는 당신의 개인정보를 보호할 것을 약속하며, 제3자와 당신의 정보를 공유하지 않습니다. 언제든지 구독을 취소할 수 있습니다.",
  
  // Footer
  quality_assurance: "품질 보증",
  about_us: "회사 소개",
  contact_us: "문의하기",
  careers: "채용 정보",
  faq: "자주 묻는 질문",
  user_guide: "사용 가이드",
  customer_service: "고객 서비스", 
  return_policy: "반품 정책",
  footer_description: "젊음의 권리를 되찾고, 자연의 가장 효과적인 슈퍼푸드를 당신의 일상 의식에 통합하여 광채와 영원한 활력을 발산하세요.",
  all_rights_reserved: "모든 권리 보유",
  privacy_policy: "개인정보 처리방침",
  terms_of_service: "서비스 약관"
};

export default common;
